import {match} from 'ts-pattern';

import {FinancingCompositionLayer} from '@dms/api/shared';
import i18n from '@dms/i18n';

const LAYER_NAME_MAX_LENGTH = 24;

/** The name the editor shows for a layer: the start of its text, or its layer type. */
export const getLayerName = (layer: FinancingCompositionLayer) =>
  match(layer)
    .with({type: 'text'}, (textLayer) =>
      textLayer.text.trim().length > 0
        ? textLayer.text.trim().slice(0, LAYER_NAME_MAX_LENGTH)
        : i18n.t('entity.watermark.composition.labels.textLayer')
    )
    .with({type: 'image'}, () => i18n.t('entity.watermark.composition.labels.imageLayer'))
    .with({type: 'rect'}, () => i18n.t('entity.watermark.composition.labels.rectLayer'))
    .with({type: 'photo'}, () => i18n.t('entity.promoPhotos.composition.labels.vehiclePhoto'))
    .exhaustive();
